// extracted by mini-css-extract-plugin
export default {"container":"Dh-z","links":"Eh-z"};